(function () {
  'use strict';

  var OFFSET = 120;

  function getOffsetTop(element) {
    var top = 0;
    while (element) {
      top += element.offsetTop;
      element = element.offsetParent;
    }
    return top;
  }

  function smoothScrollTo(targetId) {
    if (!targetId) return;

    var target = document.getElementById(targetId)
              || document.querySelector('[data-anchor="' + targetId + '"]');
    if (!target) return;

    var top = getOffsetTop(target) - OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  // Intercept all hash link clicks
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href) return;

    // Only handle same-page anchors
    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return;

    var beforeHash = href.substring(0, hashIndex);
    if (beforeHash && beforeHash !== window.location.pathname && beforeHash !== window.location.href.split('#')[0]) return;

    var hash = href.substring(hashIndex + 1);
    if (!hash) return;

    var target = document.getElementById(hash)
              || document.querySelector('[data-anchor="' + hash + '"]');
    if (!target) return;

    e.preventDefault();
    smoothScrollTo(hash);
    history.pushState(null, '', '#' + hash);
  });

  // Scroll to hash on page load
  if (location.hash) {
    var hash = location.hash.replace('#', '');
    // Delay to let layout settle
    setTimeout(function () {
      smoothScrollTo(hash);
    }, 300);
  }
})();
